import { SB } from '@play-co/replicant';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import {
  createFlexContainer,
  createFlexMessageTemplate,
  createOpenGameAction,
} from './utils';
import { getPetAssetKey, speciesAssetsRatio, speciesChatbot } from './species';
import { buildSender } from '../sender';

/**
 * Assets for visited messages
 */
export const visitedAssets = {
  'background/visited': 'private/chatbot/visit/friendvisit_bg_new.png',
  'text/visited_en': 'private/chatbot/visit/visited_en.png',
  'text/visited_ja': 'private/chatbot/visit/visited_ja.png',
};

/**
 * Create visited message
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const visitedMessage = createFlexMessageTemplate(
  SB.object({
    species: SB.tuple(speciesChatbot),
    locale: SB.tuple(['en', 'ja']),
    petName: SB.string(),
    visitor: SB.object({
      name: SB.string(),
      photo: SB.string(),
      pet: SB.tuple(speciesChatbot),
    }),
  }),
  (data, payload, api) => {
    const text = getLocaleConfig(data.locale).visit.finish.text.replace(
      '{name}',
      data.visitor.name,
    );
    const petAssetKey = getPetAssetKey(data.species, 'happy');
    const petIcon = api.getAssetPath(petAssetKey);
    const friendAssetKey = getPetAssetKey(data.visitor.pet, 'happy');
    const friendIcon = api.getAssetPath(friendAssetKey);

    const template = createFlexContainer(text, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(text, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        paddingAll: '0px',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath('background/visited'),
            size: 'full',
            aspectMode: 'cover',
            gravity: 'center',
            aspectRatio: '1.3:1',
          },
          {
            type: 'box',
            layout: 'vertical',
            contents: [
              {
                type: 'image',
                url: api.getAssetPath(`text/visited_${data.locale}`),
                size: 'full',
                aspectRatio: '4:1',
                gravity: 'top',
                offsetTop: '-2%',
              },
            ],
            position: 'absolute',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-start',
          },
          {
            type: 'box',
            layout: 'horizontal',
            position: 'absolute',
            width: '100%',
            alignItems: 'flex-end',
            height: '100%',
            contents: [
              {
                type: 'image',
                url: friendIcon,
                aspectRatio: speciesAssetsRatio[friendAssetKey],
                size: '65%',
                position: 'relative',
              },
              {
                type: 'image',
                url: petIcon,
                aspectRatio: speciesAssetsRatio[petAssetKey],
                size: '65%',
                position: 'relative',
                offsetStart: '1%',
              },
            ],
            offsetTop: '-31%',
            offsetStart: '2%',
          },
          {
            type: 'box',
            layout: 'vertical',
            contents: [
              {
                type: 'image',
                url: api.getAssetPath(`button/playnow_${data.locale}`),
                position: 'relative',
                size: '55%',
                offsetBottom: '-20%',
              },
            ],
            position: 'absolute',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
          },
        ],
      },
    });

    // Add sender to message
    template['sender'] = buildSender({
      name: data.petName,
      iconUrl: api.getAssetPath(getPetAssetKey(data.species)),
    });

    return template;
  },
);
